export default __webpack_public_path__ + "static/media/about.a3648d38.jpg";